import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { ValidationService } from '../../shared/providers/validation.service';
import { ToastService } from '../../shared/providers/toast.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../../shared/providers/loader.service';

interface IAddPropertyNote {
    PropertyId: number;
    UserId: number;
    Note: string;
    IsFlag: boolean | null;
}

interface IPropertyNotes {
    Id: number;
    Note: string;
    UserName: string;
    CreatedDate: Date;
    TypeId: number;
    IsResolved: boolean | null;
    ResolvedBy: string;
    ResolvedDate: Date | null;
    IsFlag: boolean;
    UserId: number;
}

@Component({
    selector: 'app-property-notes',
    templateUrl: './property-notes.component.html'
})
export class PropertyNotesComponent implements OnInit {
    @Input() propertyId: number;
    @Input() IsPDeleted: boolean = false;
    @Input() modalRef: BsModalRef;
    @Output() saveNotes = new EventEmitter();
    addPropertyNote = {} as IAddPropertyNote;

    constructor(public Validation: ValidationService, private Loader: LoaderService, private modalService: BsModalService, public authService: AuthenticationService, private propertyManagementService: PropertyManagementService, private Toast: ToastService) { }
    user: any;
    loadComplete = false;
    ngOnInit() {
        this.user = this.authService.user;
      if (this.user) {
        if (this.user.RoleId == (this.authService.UserRole.Admin) || this.user.RoleId == (this.authService.UserRole.SuperAdmin) || this.user.RoleId == (this.authService.UserRole.Broker) || this.user.RoleId == (this.authService.UserRole.DataEntryStaff)) {
                if (!this.Validation.IsinValid(this.propertyId)) {
                    this.loadComplete = true;
                    this.GetPropertyNotes(3);
                }
            }
        }
    }
    propertyNotesList: IPropertyNotes[];
    propertyNotesListAll: IPropertyNotes[];
    showLoadMoreNoteBtn = true;
    unResolvedFlag = 0;
    GetPropertyNotes(fetchCount) {
        this.propertyManagementService.GetPropertyNotes(this.propertyId, 0, this.user.Id).subscribe(response => {
            this.propertyNotesListAll = response;
            if (this.user.RoleId == (this.authService.UserRole.DataEntryStaff)) {
              //Data Entry Staff will be able to view only the flagged notes. They won't have access to notes
              this.propertyNotesListAll = this.propertyNotesListAll.filter(x => (x.IsFlag == true || x.TypeId == 2752));
            }
            if (fetchCount == 0) {
                this.showLoadMoreNoteBtn = false;
                this.propertyNotesList = this.propertyNotesListAll;
            }
            else if (fetchCount == 3) {
                this.showLoadMoreNoteBtn = true;
                this.propertyNotesList = this.propertyNotesListAll.slice(0, fetchCount);
            }
            this.getUnResolvedFlagCount();
        });
    }

    getUnResolvedFlagCount() {
        this.unResolvedFlag = this.propertyNotesListAll.filter(x => x.IsFlag == true && x.IsResolved == false).length;
    }

    isSubmit = false;
    disableBtn = false;
    onAddNotes() {
        this.isSubmit = true;
        this.disableBtn = true;
        if (!this.Validation.IsinValid(this.addPropertyNote.Note)) {
            this.Loader.display(true);
            this.addPropertyNote.PropertyId = this.propertyId;
            this.addPropertyNote.UserId = this.user.Id;
            this.propertyManagementService.savepropertyNotes(this.addPropertyNote).subscribe(res => {
                this.reloadList(true);
                this.Toast.addToast({ title: 'Success', msg: 'Note added successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                this.GetPropertyNotes(3);
                this.disableBtn = false;
                this.Loader.display(false);
                this.modalRef.hide();
            });
        }
        else {
            this.disableBtn = false;
        }
    }
    openPropertyNotesModal(template: TemplateRef<any>, classes: any) {
        this.addPropertyNote = {} as IAddPropertyNote;
        this.isSubmit = false;
        this.modalRef = this.modalService.show(template, { class: classes });
    }

    reloadList(status) {
        if (status) {
            this.GetPropertyNotes(3);
        }
    }
    onResolveFlag(flagId) {
        this.Loader.display(true);
        this.propertyManagementService.resolveflag(flagId, this.user.Id).subscribe(response => {
            this.Loader.display(false);
            if (response) {
                this.Toast.addToast({ title: 'Success', msg: 'Flag has been resolved.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                if (this.propertyNotesList.length > 3) {
                    this.GetPropertyNotes(0);
                }
                else {
                    this.GetPropertyNotes(3);
                }
                this.unResolvedFlag = this.unResolvedFlag - 1;
            }
        });
    }

    modalRefNote: BsModalRef;
    selectedNote = 0;
    openRemoveNoteModal(template: TemplateRef<any>, id: number) {
        this.selectedNote = id;
        this.modalRefNote = this.modalService.show(template, { class: 'deletemodal' });
    }
    onRemoveNote(Id) {
        this.Loader.display(true);
        this.propertyManagementService.removenote(Id).subscribe(response => {
            if (response) {
                this.Toast.addToast({ title: 'Success', msg: 'Note has been removed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                let index = this.propertyNotesListAll.findIndex(x => x.Id == Id);
                if (index > -1) {
                    this.propertyNotesListAll.splice(index, 1);
                }
                if (this.propertyNotesList.length > 3) {
                    let index = this.propertyNotesList.findIndex(x => x.Id == Id);
                    if (index > -1) {
                        this.propertyNotesList.splice(index, 1);
                    }
                }
                else {
                    this.propertyNotesList = this.propertyNotesListAll;
                    this.propertyNotesList = this.propertyNotesList.slice(0, 3);
                }
                this.getUnResolvedFlagCount();
            }
            this.Loader.display(false);
        });
    }
}

